type UseExpiringLocalStorage<T> = [() => T, (value: T) => void, () => void]

export const useExpiringLocalStorage = <T>(
  key: string,
  initialValue: T,
  expirationTime: number,
): UseExpiringLocalStorage<T> => {
  const setItem = (value: T): void => {
    const expireAt = Date.now() + expirationTime
    const item = {
      value,
      expireAt,
    }
    localStorage.setItem(key, JSON.stringify(item))
  }

  const getItem = (): T => {
    const itemStr = localStorage.getItem(key)
    if (!itemStr) return initialValue

    const item = JSON.parse(itemStr)
    if (Date.now() > item.expireAt) {
      localStorage.removeItem(key)
      return initialValue
    }
    return item.value
  }

  const removeItem = (): void => {
    localStorage.removeItem(key)
  }

  return [getItem, setItem, removeItem]
}
